var map = {
	"./akiMouse.png": "409e",
	"./akiMouseResize.png": "a6dc",
	"./akiNoises/a.mp3": "0fcf",
	"./akiNoises/ameno1.mp3": "bf2e",
	"./akiNoises/ameno2.mp3": "381a",
	"./akiNoises/amenoAmeno.mp3": "1379",
	"./akiNoises/ba.mp3": "1764",
	"./akiNoises/be.mp3": "75b3",
	"./akiNoises/bi.mp3": "d920",
	"./akiNoises/bo.mp3": "fe1f",
	"./akiNoises/bu.mp3": "ba2a",
	"./akiNoises/cheers.mp3": "3cef",
	"./akiNoises/da.mp3": "7324",
	"./akiNoises/de.mp3": "675a",
	"./akiNoises/di.mp3": "e691",
	"./akiNoises/do.mp3": "8b45",
	"./akiNoises/dorime1.mp3": "6a0a",
	"./akiNoises/dorime2.mp3": "069a",
	"./akiNoises/dorime3.mp3": "6a96",
	"./akiNoises/du.mp3": "ea2d",
	"./akiNoises/duhDuhduh.mp3": "faa3",
	"./akiNoises/e.mp3": "62bc",
	"./akiNoises/explosion.mp3": "ea28",
	"./akiNoises/ga.mp3": "b8a4",
	"./akiNoises/ge.mp3": "21b5",
	"./akiNoises/gi.mp3": "3c18",
	"./akiNoises/giggle.mp3": "4a42",
	"./akiNoises/giggle2.mp3": "c91c",
	"./akiNoises/giggle3.mp3": "0436",
	"./akiNoises/go.mp3": "ece7",
	"./akiNoises/gu.mp3": "0fc3",
	"./akiNoises/ha.mp3": "6d40",
	"./akiNoises/he.mp3": "06eb",
	"./akiNoises/hi.mp3": "6194",
	"./akiNoises/ho.mp3": "9513",
	"./akiNoises/hu.mp3": "d596",
	"./akiNoises/i.mp3": "8810",
	"./akiNoises/imeterinano.mp3": "83ff",
	"./akiNoises/iterimoAdapareDorime.mp3": "1930",
	"./akiNoises/japaneseAnimation.mp3": "9bdd",
	"./akiNoises/justDoIt1.mp3": "1ef2",
	"./akiNoises/justDoIt2.mp3": "6f94",
	"./akiNoises/justDoIt3.mp3": "32b2",
	"./akiNoises/justDoIt4.mp3": "2fde",
	"./akiNoises/ka.mp3": "1bcc",
	"./akiNoises/kanpai.mp3": "e3f0",
	"./akiNoises/ke.mp3": "11b7",
	"./akiNoises/ki.mp3": "e5aa",
	"./akiNoises/ko.mp3": "0aeb",
	"./akiNoises/konosuba.mp3": "0cd1",
	"./akiNoises/ku.mp3": "044d",
	"./akiNoises/latire.mp3": "bb77",
	"./akiNoises/latiremo.mp3": "2480",
	"./akiNoises/ma.mp3": "5513",
	"./akiNoises/machiheno.mp3": "32da",
	"./akiNoises/machino.mp3": "f773",
	"./akiNoises/me.mp3": "0321",
	"./akiNoises/mi.mp3": "6c38",
	"./akiNoises/mo.mp3": "7297",
	"./akiNoises/mu.mp3": "32ec",
	"./akiNoises/n.mp3": "22e9",
	"./akiNoises/na.mp3": "789a",
	"./akiNoises/ne.mp3": "417f",
	"./akiNoises/neko.mp3": "282b",
	"./akiNoises/ni.mp3": "99ec",
	"./akiNoises/no0.mp3": "38bd",
	"./akiNoises/no1.mp3": "2627",
	"./akiNoises/no10.mp3": "efde",
	"./akiNoises/no11.mp3": "8128",
	"./akiNoises/no12.mp3": "f257",
	"./akiNoises/no13.mp3": "c8b0",
	"./akiNoises/no14.mp3": "03f2",
	"./akiNoises/no15.mp3": "1381",
	"./akiNoises/no2.mp3": "7527",
	"./akiNoises/no3.mp3": "a63d",
	"./akiNoises/no4.mp3": "5803",
	"./akiNoises/no5.mp3": "4095",
	"./akiNoises/no6.mp3": "ed86",
	"./akiNoises/no7.mp3": "0d59",
	"./akiNoises/no8.mp3": "966e",
	"./akiNoises/no9.mp3": "0207",
	"./akiNoises/noPineapple1.mp3": "7ed2",
	"./akiNoises/noPineapple10.mp3": "d5e5",
	"./akiNoises/noPineapple11.mp3": "d488",
	"./akiNoises/noPineapple12.mp3": "bffb",
	"./akiNoises/noPineapple13.mp3": "7fab",
	"./akiNoises/noPineapple2.mp3": "0b00",
	"./akiNoises/noPineapple3.mp3": "c0e6",
	"./akiNoises/noPineapple4.mp3": "4a6a",
	"./akiNoises/noPineapple5.mp3": "a445",
	"./akiNoises/noPineapple6.mp3": "46f3",
	"./akiNoises/noPineapple7.mp3": "f8f6",
	"./akiNoises/noPineapple8.mp3": "4a1d",
	"./akiNoises/noPineapple9.mp3": "9e42",
	"./akiNoises/nu.mp3": "1ec9",
	"./akiNoises/nyan1.mp3": "8dcb",
	"./akiNoises/nyan2.mp3": "f520",
	"./akiNoises/nyan3.mp3": "98e3",
	"./akiNoises/nyan4.mp3": "d39d",
	"./akiNoises/nyan5.mp3": "077d",
	"./akiNoises/nyan6.mp3": "44c2",
	"./akiNoises/nyan7.mp3": "b06d",
	"./akiNoises/o.mp3": "35fd",
	"./akiNoises/pa.mp3": "dd6e",
	"./akiNoises/pe.mp3": "187e",
	"./akiNoises/pi.mp3": "4f6e",
	"./akiNoises/po.mp3": "51cb",
	"./akiNoises/pu.mp3": "aa15",
	"./akiNoises/ra.mp3": "24b2",
	"./akiNoises/re.mp3": "b6aa",
	"./akiNoises/ri.mp3": "b512",
	"./akiNoises/ro.mp3": "9a47",
	"./akiNoises/ru.mp3": "d768",
	"./akiNoises/sa.mp3": "f1d0",
	"./akiNoises/se.mp3": "7b6b",
	"./akiNoises/si.mp3": "201e",
	"./akiNoises/so.mp3": "c560",
	"./akiNoises/su.mp3": "76b5",
	"./akiNoises/ta.mp3": "d646",
	"./akiNoises/te.mp3": "168a",
	"./akiNoises/ti.mp3": "172f",
	"./akiNoises/to.mp3": "9711",
	"./akiNoises/tu.mp3": "a91e",
	"./akiNoises/u.mp3": "8ac7",
	"./akiNoises/umandeimepibeameno.mp3": "2ec4",
	"./akiNoises/wa.mp3": "1abf",
	"./akiNoises/wafoo1.mp3": "2505",
	"./akiNoises/wafoo2.mp3": "fc2d",
	"./akiNoises/wafoo3.mp3": "ff5d",
	"./akiNoises/wahoo.mp3": "c548",
	"./akiNoises/wo.mp3": "42db",
	"./akiNoises/ya.mp3": "fca9",
	"./akiNoises/yes0.mp3": "a7e8",
	"./akiNoises/yes1.mp3": "454c",
	"./akiNoises/yes2.mp3": "5969",
	"./akiNoises/yes3.mp3": "fb01",
	"./akiNoises/yes4.mp3": "c6eb",
	"./akiNoises/yes5.mp3": "ca69",
	"./akiNoises/yes6.mp3": "5dbd",
	"./akiNoises/yes7.mp3": "b0e5",
	"./akiNoises/yes8.mp3": "11a2",
	"./akiNoises/yo.mp3": "945c",
	"./akiNoises/yu.mp3": "0b51",
	"./akiNoises/za.mp3": "1401",
	"./akiNoises/ze.mp3": "e8f9",
	"./akiNoises/zi.mp3": "83ed",
	"./akiNoises/zo.mp3": "2b53",
	"./akiNoises/zu.mp3": "87ed",
	"./akiPoses/correct0.png": "7010",
	"./akiPoses/correct1.png": "d341",
	"./akiPoses/correct2.png": "8ce8",
	"./akiPoses/correct3.png": "077f",
	"./akiPoses/correct4.png": "2eee",
	"./akiPoses/incorrect0.png": "604a",
	"./akiPoses/incorrect1.png": "b839",
	"./akiPoses/incorrect2.png": "6de4",
	"./akiPoses/incorrect3.png": "dd5d",
	"./akiPoses/incorrect4.png": "a577",
	"./akiPoses/incorrect5.png": "a66b",
	"./akiPoses/incorrect6.png": "afd9",
	"./akiPoses/prompt0.png": "7694",
	"./appleBtn0.png": "54b8",
	"./appleBtn1.png": "d130",
	"./appleBtn2.png": "3b1a",
	"./audioVidThumbnail.jpg": "d299",
	"./bg1.png": "852b",
	"./kana": "82b1",
	"./kana.json": "82b1",
	"./logo.png": "cf05",
	"./portrait.webp": "1f1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";